module.exports = __webpack_public_path__ + "img/orderRecomd.6cbd943c.png";